import { useEffect, useState } from "react";
import Login from "./components/Login/Login";
import { domainMap, DEFAULT_ACCOUNT } from "./constants/index.js";
import "./App.css";

const location = window.location.hostname;
const rootName = location ? location.split(".").slice(-2)[0] : "";
const rootDomain = location ? location.split(".").slice(-2).join(".") : "";

function setCookie(a, b, c, dom) {
    var d = new Date();
    d.setDate(d.getDate() + c);
    var e = escape(b) + (c == null ? "" : ";expires=" + d.toUTCString());
    var domain = dom != null ? ";domain=" + dom : "";
    document.cookie = a + "=" + e + domain;
}

function deleteCookie(name, path, domain) {
    document.cookie =
        name +
        "=" +
        (path ? ";path=" + path : "") +
        (domain ? ";domain=" + domain : "") +
        ";expires=Thu, 01-Jan-1970 00:00:01 GMT";
}

function getUrlVal(str) {
    var v = window.location.search.match(
        new RegExp("(?:[?&]" + str + "=)([^&]+)")
    );
    return v ? v[1] : null;
}

function App() {
    const {
        name: accountName = "spotter",
        host: accountHost = "https://v3.spottertech.com",
        account: accountKey = DEFAULT_ACCOUNT,
        logoPath = "/images/spotter.png",
        logoTransparent = true,
        faviconPath = "/images/spotter-ico.png",
        themeVars = {},
    } = domainMap[rootName] || {};

    const [userAccount, setUserAccount] = useState(accountKey);

    const resolveLogin = (loginInfo) => {
        const { token = "" } = loginInfo;
        setCookie("token", token, null, rootDomain);

        let tokenUrl = accountHost;

        let origin = getUrlVal("spotterOrigin") || getUrlVal("origin");
        let unsecure =
            getUrlVal("spotterOriginDev") || getUrlVal("originUnsecure");
        let port = getUrlVal("spotterOriginPort") || getUrlVal("originPort");
        if (origin) {
            let protocol = unsecure ? "http://" : "https://";
            tokenUrl = protocol + origin + "." + rootDomain;
            if (port) tokenUrl += ":" + port;
        }
        document.location = tokenUrl;
        // console.log(`set location ${tokenUrl}`);
        setTimeout(() => {
            deleteCookie("token", "/", rootDomain);
        }, 5000);
    };

    useEffect(() => {
        let urlAccount = getUrlVal("account");
        if (urlAccount) {
            setUserAccount(urlAccount);
        }
    }, []);

    useEffect(() => {
        // set document title and favicon
        document.title = accountName + " Login";

        let favicon = document.querySelector("link[rel~='icon']");
        if (!favicon) {
            favicon = document.createElement("link");
            favicon.rel = "icon";
            document.head.appendChild(favicon);
        }
        favicon.href = faviconPath;
    }, [accountName, faviconPath]);

    return (
        <div style={themeVars}>
            <Login
                userAccount={userAccount}
                resolveLogin={resolveLogin}
                logoPath={logoPath}
                logoTransparent={logoTransparent}
                accountName={accountName}
            />
        </div>
    );
}

export default App;
